export const FIXTURE_STATE_CONFIG = {
    // --- PRE-MATCH ---
    NOT_STARTED: 'NOT_STARTED',

    // --- LIVE ---
    FIRST_HALF: 'FIRST_HALF',
    HALF_TIME: 'HALF_TIME',
    SECOND_HALF: 'SECOND_HALF',
    EXTRA_TIME: 'EXTRA_TIME',
    PENALTY_SHOOTOUT: 'PENALTY_SHOOTOUT',
    BREAK_TIME: 'BREAK_TIME',

    // --- FINISHED ---
    FULL_TIME: 'FULL_TIME',
    FINISHED_AFTER_EXTRA_TIME: 'FINISHED_AFTER_EXTRA_TIME',
    FINISHED_AFTER_PENALTIES: 'FINISHED_AFTER_PENALTIES',

    // --- CANCELLED ---
    POSTPONED: 'POSTPONED',
    CANCELLED: 'CANCELLED',
    ABANDONED: 'ABANDONED',
    WALKOVER: 'WALKOVER',
};

export const STORAGE_KEYS = {
    CONTEST_SOURCE: 'gojo_contest_source',
    VISITOR_ID: 'gojo_vid',
    // Referral code carried from an invitation link (?ref=), used at sign-up for attribution.
    REFERRAL_CODE: 'gojo_referral_code'
};

export const TRACK_EVENT = {
    VIEW: 'VIEW',
    GOOGLE_REVIEW_CLICK: 'GOOGLE_REVIEW_CLICK',
    GOOGLE_REVIEW_MODAL_VIEW: 'GOOGLE_REVIEW_MODAL_VIEW',
    GOOGLE_REVIEW_MODAL_CLICK: 'GOOGLE_REVIEW_MODAL_CLICK'
};